// extracted by mini-css-extract-plugin
module.exports = {"checkboxLabel":"styles_checkboxLabel__3C06f","checked":"styles_checked__2lqvI","checkbox":"styles_checkbox__3fCGu"};